import React from 'react';
import { Formik, FormikHelpers } from 'formik';
import { ApiError } from '../../../api/api';
import { PrimaryProgressButton } from '../../../shared/Button';
import { Form, FormErrorBox } from '../../../shared/form/Form';
import { FastTextInputField } from '../../../shared/form/inputs/TextInputField';
import { HandoverPackSectionFormModel, handoverPackSectionFormModelValidator } from './handoverPackSectionFormModel';

type Props = {
  initialValues: HandoverPackSectionFormModel;
  onSubmit: (
    formModel: HandoverPackSectionFormModel,
    formikHelpers: FormikHelpers<HandoverPackSectionFormModel>,
  ) => void;
  error: ApiError | null;
};

export const CreateOrUpdateHandoverPackSectionForm = ({ initialValues, onSubmit, error }: Props) => {
  return (
    <>
      <Formik<HandoverPackSectionFormModel>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={handoverPackSectionFormModelValidator.validate}
      >
        {formProps => (
          <Form>
            <FastTextInputField name="sectionName" label="Section Name" />
            <FastTextInputField name="sectionSequence" label="Section Sequence" />
            <PrimaryProgressButton inProgress={formProps.isSubmitting} type="submit">
              Save
            </PrimaryProgressButton>
          </Form>
        )}
      </Formik>
      {error && <FormErrorBox error={error} />}
    </>
  );
};
